import { useState } from 'react';
import { archiveFinancialCatalogRecord, type FinancialCatalogKind } from '../../services/FinancialCatalogService';

export default function FinancialArchiveDialog({ clientId, kind, recordId, name, recordUsed = false, onClose, onArchived }: {
  clientId: string; kind: FinancialCatalogKind; recordId: string; name: string; recordUsed?: boolean;
  onClose: () => void; onArchived: () => void;
}) {
  const inactivate = (kind === 'organization' || kind === 'payer_link') && recordUsed;
  const action = inactivate ? 'Inativar' : 'Excluir';
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  async function confirm() {
    setSaving(true); setError('');
    try {
      await archiveFinancialCatalogRecord({ clientId, kind, recordId });
      onArchived();
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : 'Não foi possível excluir o cadastro.');
      setSaving(false);
    }
  }
  return <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/50 p-4" role="dialog" aria-modal="true" aria-labelledby="financial-archive-title">
    <div className="w-full max-w-lg space-y-4 rounded-lg bg-white p-6 shadow-xl">
      <h3 id="financial-archive-title" className="text-lg font-semibold">{inactivate ? kind === 'payer_link' ? 'Inativar pagador?' : 'Inativar organização?' : 'Excluir cadastro?'}</h3>
      <p className="text-sm text-gray-700"><strong>{name}</strong> {kind === 'organization' ? 'será inativada se já tiver sido utilizada. Somente organizações e convênios nunca utilizados podem ser excluídos. Os vínculos e o histórico serão preservados.' : kind === 'payer_link' ? 'será inativado se já tiver sido utilizado. Somente pagadores nunca utilizados podem ser excluídos. Contratos, cobranças, pagamentos e histórico serão preservados.' : 'deixará de estar disponível para novos usos. Os registros anteriores, valores, vínculos e histórico serão preservados.'}</p>
      {error && <p role="alert" className="rounded border border-red-200 bg-red-50 p-3 text-sm text-red-800">{error}</p>}
      <div className="flex justify-end gap-3 border-t pt-4">
        <button type="button" disabled={saving} onClick={onClose} className="rounded-md border px-4 py-2 disabled:opacity-50">Cancelar</button>
        <button type="button" disabled={saving} onClick={() => void confirm()} className="rounded-md bg-red-600 px-4 py-2 font-medium text-white disabled:opacity-50">{saving ? 'Salvando…' : action}</button>
      </div>
    </div>
  </div>;
}
